import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative z-10 mx-auto" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "space-y-8" }
const _hoisted_6 = { class: "flex space-x-6 text-sm rounded" }
const _hoisted_7 = { class: "flex justify-center w-full" }
const _hoisted_8 = { class: "w-full space-y-6" }
const _hoisted_9 = { class: "max-w-5xl pb-6 mx-auto md:flex md:items-center md:justify-between" }
const _hoisted_10 = { class: "items-center space-y-3 sm:-mx-4 sm:divide-x sm:divide-gray-200 md:flex md:space-y-0" }
const _hoisted_11 = { class: "relative block text-center border border-clay-500 md:text-left md:inline-block sm:border-0" }
const _hoisted_12 = {
  key: 0,
  class: "font-semibold tabular-nums text-gray-700 pl-1.5 underline"
}
const _hoisted_13 = { class: "space-y-4" }
const _hoisted_14 = { class: "max-w-6xl px-4 mx-auto sm:px-6 lg:px-8" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  class: "grid grid-cols-1 gap-10 pb-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sp",
  role: "list"
}

import {computed, defineComponent, onMounted, ref, Ref, watch} from "vue";
import {client} from '@/shared';
import {
    AuditionDTO,
    GetAllTerritories,
    SearchTheatreAuditionsByFiltersRequest,
    SearchTheatreAuditionsByFiltersResponse,
    Region,
} from "@/dtos";
import TerritoriesTab from "@/../Features/Territories/TerritoriesTab.vue";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
// @ts-ignore
import {CheckIcon, ChevronDownIcon, SelectorIcon} from '@heroicons/vue/20/solid';
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";

import {
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from '@headlessui/vue'

import {MapPinIcon} from '@heroicons/vue/20/solid'
import EmptyResultsNotification from "@/main/components/EmptyResultsNotification.vue";
import {XCircleIcon} from "@heroicons/vue/24/outline";
import AuditionCard from "./AuditionCard.vue";

const nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

const prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;



export default /*@__PURE__*/_defineComponent({
  __name: 'SearchTheatreAuditions',
  setup(__props) {

// @ts-ignore
const territories: Ref<Array<Region>> = ref([]);
const userPreferredRegion: Ref<Region> = ref({});
const territoryQuery = ref('');

const shouldScroll = ref(false);
const auditionsRetrieved = ref(false);
const searchTheatreAuditionsByFilterResponse = ref(new SearchTheatreAuditionsByFiltersResponse({
    results: Array<AuditionDTO>()
}));

const request = ref(new SearchTheatreAuditionsByFiltersRequest({
    territoryId: ''
}));

const resultsSection = ref(null);

onMounted(async () => {
    await client.get<Array<Region>>(new GetAllTerritories())
        .then(res => {
            territories.value = res.sort((a: Region, b: Region) => a.name.localeCompare(b.name));
        });
});

const filteredTerritories = computed(() =>
    territoryQuery.value === ''
        ? territories.value
        : territories.value.filter((territory: Region) => {
                return territory.name.toLowerCase().includes(territoryQuery.value.toLowerCase())
            }
        )
)

const onRegionSelected = async (territory: Region) => {
    userPreferredRegion.value = territory;
}

const clearSelectedRegion = async () => {
    userPreferredRegion.value = {};
};

const filter = async () => {
    auditionsRetrieved.value = false;
    
    request.value.territoryId = userPreferredRegion.value.id;

    await client.get<SearchTheatreAuditionsByFiltersResponse>(request.value)
        .then(res => {
            auditionsRetrieved.value = true;
            searchTheatreAuditionsByFilterResponse.value = res;
            if(shouldScroll.value){
                resultsSection.value.scrollIntoView({
                    behavior: "smooth"
                });
            }
            shouldScroll.value = true;
        });
}

const resetFilters = async () => {
    request.value = new SearchTheatreAuditionsByFiltersRequest({
        territoryId: ''
    });
    userPreferredRegion.value = {};
}

const clickHandler = async (pageNum: any) => {
    request.value.currentPage = pageNum;
    await filter();
}

const getPageCount = () => {
    return Math.ceil(searchTheatreAuditionsByFilterResponse.value.totalResults / 12);
}

watch([
        () => userPreferredRegion.value,
    ], async ([]) => {
        request.value.currentPage = 1;
        await filter();
    },
    { immediate: true }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"p-4 rounded-md bg-sa-red-500\"><div class=\"max-w-5xl mx-auto\"><div class=\"flex\"><div class=\"shrink-0\"></div><div class=\"flex-1 ml-3 md:flex md:justify-between\"><p class=\"text-white\">We have launched our new theatre opportunities hub with auditions, performance listings and educational opportunities. <a href=\"/opportunities/auditions-jobs\" class=\"underline\">Check it out!</a></p><p class=\"mt-4 text-sm md:ml-6\"><a href=\"/opportunities/auditions-jobs\" class=\"px-4 py-2 font-medium bg-white rounded-lg whitespace-nowrap\">Opportunities Hub<span aria-hidden=\"true\"> →</span></a></p></div></div></div></div>", 1)),
    _createElementVNode("div", {
      ref_key: "resultsSection",
      ref: resultsSection,
      class: "min-h-screen py-8 bg-zinc-50"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", {
            "aria-hidden": "true",
            class: "absolute inset-0 flex flex-col"
          }, [
            _createElementVNode("div", { class: "flex-1" }),
            _createElementVNode("div", { class: "flex-1 w-full" })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_unref(PopoverGroup), { class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Popover), { class: "" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_unref(PopoverButton), { class: "inline-flex justify-center min-w-full px-4 py-2 text-sm font-medium text-gray-700 uppercase group hover:text-gray-900 sm:py-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(MapPinIcon), {
                                          class: "w-5 h-5 mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
                                          "aria-hidden": "true"
                                        }),
                                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-gray-700 hover:text-gray-900" }, "Near", -1)),
                                        (userPreferredRegion.value.name)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(userPreferredRegion.value.name), 1))
                                          : _createCommentVNode("", true),
                                        (userPreferredRegion.value.name)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              class: "ml-1 text-sa-red-600",
                                              onClick: clearSelectedRegion
                                            }, [
                                              _createVNode(_unref(XCircleIcon), { class: "inline h-5 w-5>" })
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode(_Transition, {
                                    "enter-active-class": "transition duration-100 ease-out",
                                    "enter-from-class": "transform scale-95 opacity-0",
                                    "enter-to-class": "transform scale-100 opacity-100",
                                    "leave-active-class": "transition duration-75 ease-in",
                                    "leave-from-class": "transform scale-100 opacity-100",
                                    "leave-to-class": "transform scale-95 opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PopoverPanel), { class: "z-10 p-4 mt-2 origin-top-left bg-white rounded-md shadow-2xl md:absolute md:w-256 ring-1 ring-black ring-opacity-5 focus:outline-hidden" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("form", _hoisted_13, [
                                            _createVNode(TerritoriesTab, {
                                              territories: territories.value,
                                              onOnRegionSelected: onRegionSelected
                                            }, null, 8, ["territories"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"sm:block\"><div class=\"flow-root\"><div class=\"items-center divide-x divide-gray-200 sm:-mx-4 sm:flex\"><div class=\"relative block min-w-full mt-3 text-center border md:text-left md:inline-block sm:border-0 sm:mt-0\"><div><a href=\"/opportunities/post\" class=\"text-sm font-medium text-gray-700 underline group hover:text-gray-900\">Post to the new theatre opportunities hub</a></div></div></div></div></div>", 1))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (auditionsRetrieved.value === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (searchTheatreAuditionsByFilterResponse.value.results?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchTheatreAuditionsByFilterResponse.value.results, (audition) => {
                        return (_openBlock(), _createBlock(AuditionCard, {
                          key: audition.id,
                          audition: audition
                        }, null, 8, ["audition"]))
                      }), 128))
                    ]),
                    _createVNode(_unref(Paginate), {
                      modelValue: searchTheatreAuditionsByFilterResponse.value.currentPage,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTheatreAuditionsByFilterResponse.value.currentPage) = $event)),
                      "active-class": 'border-clay-500 text-clay-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium',
                      "click-handler": clickHandler,
                      "container-class": 'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0 mt-8',
                      "margin-pages": 2,
                      "next-class": '-mt-px w-0 flex-1 flex justify-end',
                      "next-link-class": 'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500',
                      "next-text": nextHtml,
                      "page-class": 'border-transparent text-clay-800 hover:text-gray-700 hover:border-clay-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium',
                      "page-count": getPageCount(),
                      "page-range": 3,
                      "prev-class": '-mt-px w-0 flex-1 flex',
                      "prev-link-class": 'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500',
                      "prev-text": prevHtml
                    }, null, 8, ["modelValue", "page-count"])
                  ]))
                : (_openBlock(), _createBlock(EmptyResultsNotification, { key: 1 }))
            ]))
          : (_openBlock(), _createBlock(SkeletonCard, {
              key: 1,
              "num-of-cards": 4
            }))
      ])
    ], 512)
  ], 64))
}
}

})